module.exports = __webpack_public_path__ + "media/images/gifts/care/sug_cuidar_3-6eee9ed3f073c13c6e8f33fa03761830.jpg";